/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'share-2': {
    width: 19,
    height: 19,
    viewBox: '0 0 19 19',
    data: '<g clip-path="url(#clip0_12544_1507)"><path pid="0" d="M13.458.982a2.975 2.975 0 010 5.95c-.88 0-1.668-.384-2.212-.99L6.776 8.55c.1.298.156.617.157.949 0 .332-.058.65-.158.947l4.473 2.608a2.974 2.974 0 11-.606 1.034L6.17 11.482a2.964 2.964 0 01-2.212.992 2.975 2.975 0 010-5.95c.879 0 1.667.384 2.212.99l4.47-2.61A2.972 2.972 0 0113.457.982zm0 12.284c-.63 0-1.182.328-1.497.822-.009.02-.016.04-.027.06-.012.021-.029.04-.043.059a1.776 1.776 0 101.567-.941zm-9.5-5.542a1.776 1.776 0 000 3.55c.652 0 1.22-.353 1.53-.877l.002-.004.006-.01a1.776 1.776 0 00-1.538-2.66zm9.5-5.542a1.776 1.776 0 10.002 3.552 1.776 1.776 0 00-.002-3.552z" _fill="#0077C8"/></g><defs><clipPath id="clip0_12544_1507"><path pid="1" _fill="#fff" d="M0 0h19v19H0z"/></clipPath></defs>'
  }
})
